import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import salonmoduleApiController from "../../services/salonmodule.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";
export const usersAdapter = createEntityAdapter();

const salonModuleErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const salonmoduleListViewApi = createAsyncThunk("salonmodule/modulelistview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonmoduleApiController
      .moduleview(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "modulelistview"))
      .catch((error) => HandleError(thunkAPI, error, "modulelistview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const salonmoduleAccessViewApi = createAsyncThunk("salonmodule/accesslistview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await salonmoduleApiController
      .accessview(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "accesslistview"))
      .catch((error) => HandleError(thunkAPI, error, "accesslistview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const salonModuleAccessUpdateApi = createAsyncThunk("salonmodule/update", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await salonmoduleApiController
      .update(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "update"))
      .catch((error) => HandleError(thunkAPI, error, "update"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

const initialState = {
  isListView: [],
  isListViewError: "",
  isAccessView: [],
  isAccessViewError: "",
  isAccess: [],
  isAccessError: "",
  isAccessUpdateError: "",
  isApiStatus: { SalonModule: "", SalonAccess: "" },
};

const salonmoduleSlice = createSlice({
  name: "salonmodule",
  initialState,
  reducers: {
    reset: () => initialState,
    salonModuleAccessAction: (state, action) => {
      const { id, ...changes } = action.payload;
      const existingData = state.isAccessView.find((event) => event.id === id);
      if (existingData) {
        Object.keys(changes).map((keyName) => {
          existingData[keyName] = changes[keyName];
        });
      }
      // state.isAddonServices = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(salonmoduleListViewApi.pending, (state) => {
      state.isListViewError = "";
      state.isApiStatus = { ...state.isApiStatus, SalonModule: "loading" };
    })
    .addCase(salonmoduleListViewApi.fulfilled, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, SalonModule: "succeeded" };
      state.isListView = action.payload;
      state.isListViewError = "";
    })
    .addCase(salonmoduleListViewApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, SalonModule: "failed" };
      state.isListViewError = salonModuleErrorMessage(action, "Unable to load salon modules.");
    })
    .addCase(salonmoduleAccessViewApi.pending, (state) => {
      state.isAccessViewError = "";
      state.isAccessError = "";
      state.isApiStatus = { ...state.isApiStatus, salonmoduleAccessViewApi: "loading" };
    })
    .addCase(salonmoduleAccessViewApi.fulfilled, (state, action) => {
      state.isAccessView = action.payload;
      const accessdata = state.isAccessView;
      let permissionModule = [];
      accessdata.map((list) => {
        let permission = [];
        list.salonpermission
          .filter((perm) => perm.access === true)
          .map((perm) => {
            permission.push(perm.name);
          });
        permissionModule.push({ permission: permission, module_id: list.id, controller: list.controller });
      });
      state.isApiStatus = { ...state.isApiStatus, salonmoduleAccessViewApi: "succeeded" };
      state.isAccess = permissionModule;
      state.isAccessViewError = "";
      state.isAccessError = "";
    })
    .addCase(salonmoduleAccessViewApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, salonmoduleAccessViewApi: "failed" };
      state.isAccessViewError = salonModuleErrorMessage(action, "Unable to load salon module access.");
      state.isAccessError = state.isAccessViewError;
    })
    .addCase(salonModuleAccessUpdateApi.pending, (state) => {
      state.isAccessUpdateError = "";
      state.isApiStatus = { ...state.isApiStatus, SalonAccessUpdate: "loading" };
    })
    .addCase(salonModuleAccessUpdateApi.fulfilled, (state) => {
      state.isApiStatus = { ...state.isApiStatus, SalonAccessUpdate: "succeeded" };
    })
    .addCase(salonModuleAccessUpdateApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, SalonAccessUpdate: "failed" };
      state.isAccessUpdateError = salonModuleErrorMessage(action, "Unable to update salon module access.");
    });
  },
});
// Action creators are generated for each case reducer function
export const { reset, salonModuleAccessAction } = salonmoduleSlice.actions;
export default salonmoduleSlice.reducer;
